import { classNames } from '@fullstory/util/fmt';
import alignContentClassNames, {
  ClassNames as AlignContent,
} from '../classes/alignContent.module.scss';
import alignItemsClassNames, { ClassNames as AlignItems } from '../classes/alignItems.module.scss';
import columnGapClassNames from '../classes/columnGap.module.scss';
import flexDirectionClassNames, {
  ClassNames as FlexDirection,
} from '../classes/flexDirection.module.scss';
import flexWrapClassNames, { ClassNames as FlexWrap } from '../classes/flexWrap.module.scss';
import gapClassNames from '../classes/gap.module.scss';
import justifyContentClassNames, {
  ClassNames as JustifyContent,
} from '../classes/justifyContent.module.scss';
import rowGapClassNames from '../classes/rowGap.module.scss';
import { SpaceScale } from '../types/scale';
import { getClassName } from '../utils/getClassName';
import { getSpaceScaleClassName } from '../utils/getScaleClassName';

export interface FlexContainerProps {
  gap?: SpaceScale;
  rowGap?: SpaceScale;
  columnGap?: SpaceScale;

  alignItems?: AlignItems;
  alignContent?: AlignContent;

  justifyContent?: JustifyContent;

  flexDirection?: FlexDirection;

  flexWrap?: FlexWrap;
}

export function getFlexContainerClassNames({
  justifyContent,
  flexDirection,
  flexWrap,
  gap,
  rowGap,
  columnGap,
  alignItems,
  alignContent,
}: FlexContainerProps = {}) {
  return classNames(
    getClassName(justifyContentClassNames, justifyContent),
    getClassName(flexDirectionClassNames, flexDirection),
    getClassName(alignItemsClassNames, alignItems),
    getClassName(alignContentClassNames, alignContent),
    getClassName(flexWrapClassNames, flexWrap),
    getSpaceScaleClassName(gapClassNames, 'gap_', gap),
    getSpaceScaleClassName(rowGapClassNames, 'rowGap_', rowGap),
    getSpaceScaleClassName(columnGapClassNames, 'columnGap_', columnGap),
  );
}
